<script lang="ts">
	import CheckIcon from '../icons/CheckIcon.svelte';
	import CloseIcon from '../icons/CloseIcon.svelte';
	import ExclamationIcon from '../icons/ExclamationIcon.svelte';
	import InfoIcon from '../icons/InfoIcon.svelte';
	import NoteIcon from '../icons/NoteIcon.svelte';
	import WarningIcon from '../icons/WarningIcon.svelte';

	export let type: AlertType = undefined;
	export { _class as class };
	export let hideIcon: boolean = false;
	type AlertType = 'success' | 'warning' | 'danger' | 'info' | 'action-center' | undefined;
	const alertTypeClasses = {
		success: `bg-green-100`,
		warning: `bg-yellow-100`,
		info: `bg-blue-100`,
		danger: `bg-red-100`,
		'action-center': `
            bg-[var(--vv-action-center-button-color,var(--vv-grey-mid))]
            !text-[var(--vv-action-center-button-text,var(--vv-black))]
            `
	};
	let _class: string = '';
	let nodeRef: any;

	function close() {}
</script>

<div
	bind:this={nodeRef}
	class="flex flex-row my-2 p-2 text-vv-black gap-4 rounded
    {alertTypeClasses[type || 'info']}
    {_class}"
	{...$$restProps}
>
	{#if !hideIcon}
		<div class="flex-none my-auto">
			{#if type === 'warning'}
				<WarningIcon width="20" height="20" color="#e79254"></WarningIcon>
			{:else if type === 'success'}
				<CheckIcon width="20" height="20" color="#22a06b"></CheckIcon>
			{:else if type === 'danger'}
				<ExclamationIcon width="20" height="20" color="#c9372c"></ExclamationIcon>
			{:else if type === 'info'}
				<InfoIcon width="20" height="20" color="#1d7afc"></InfoIcon>
			{:else if type === 'action-center'}
				<NoteIcon
					width="20"
					height="20"
					color="!text-[var(--vv-action-center-button-text,var(--vv-black))]"
				></NoteIcon>
			{/if}
		</div>
	{/if}
	<div class="grow">
		<slot class="my-auto" />
	</div>
	<div>
		<button
			class="flex-none cursor-pointer"
			on:click={() => nodeRef.parentNode.removeChild(nodeRef)}
		>
			<CloseIcon width="20" height="20"></CloseIcon>
		</button>
	</div>
</div>
